import PropTypes from 'prop-types';

import styled from '@emotion/styled';

import Image from 'next/image';

import Typography from 'Components/Typography';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import useResponsiveVariant from 'utils/useResponsiveVariant';

const ImageContainer = styled(Image)`
  width: 100%;
  height: auto;
`;

const LinkWrapper = styled(Typography)`
  font-size: 32px;
  margin: 16px 0 48px;

  & a {
    text-decoration: none;
  }
  ${props => props.theme.breakpoints.up('sm')} {
    font-size: 48px;
    margin-bottom: 32px;
  }

  ${props => props.theme.breakpoints.up('md')} {
    margin-bottom: 0;
  }
`;

const ContentWrapper = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f0eb;
  justify-content: center;
  align-items: center;
  padding: 64px 7%;
  ${props => props.theme.breakpoints.up('md')} {
    padding-top: 96px;
  }
`;

const UgcBlock = ({ content }) => {
  const { isTablet, isMobile } = useResponsiveVariant();

  const instagramTag = content.secondaryTitle;

  return (
    <ContentWrapper>
      <Typography color="noir" markupName="h2" variant="mono2">
        {content.title}
      </Typography>

      <LinkWrapper color="noir" markupName="p" variant="hero2">
        <a
          data-click="ig"
          data-from="block-ugc"
          href={`https://www.instagram.com/explore/tags/${instagramTag}/`}
          rel="noopener noreferrer"
          target="_blank"
        >
          #{instagramTag}
        </a>
      </LinkWrapper>

      <ImageContainer
        alt={content.alt}
        src={isMobile ? content.imageM : isTablet ? content.imageT : content.image}
      />
    </ContentWrapper>
  );
};

UgcBlock.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    secondaryTitle: PropTypes.string.isRequired,
    image: srcOrNextImageProp.isRequired,
    imageM: srcOrNextImageProp.isRequired,
    imageT: srcOrNextImageProp.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
};

export default UgcBlock;
